<template>
    <div class="mvt-seolink" :class="{'rentals': glb.rentals}" v-if="sectionVisibility">
        <div class="seo-list" v-if="cityLinks && cityLinks.length">
            <div class="text-bold">{{molang('search.common.cities')}}</div>
            <ul>
                <template v-for="(item, i) in cityLinks" :key="i">
                    <li v-if="item.cityPath" v-show="showMore.city || i < maxCount">
                        <a class="link" :href="glb.appUrl + item.cityPath" :title="molang(`search.common.seoLinksTitleTooltip${glb.rentLang}`, {displayName: item.city, stateCode: item.state })"  :count="$filters.formatFriendlyPrice(item.medianListPrice, '-')">
                            {{linkPrefix}} {{item.city}}
                        </a>
                    </li>
                </template>
            </ul>
            <a v-if="showSiteMapLinks" :href="glb.appUrl + 'sitemap/' + cityLinks[0].stateCode + '/'" class="link">See More</a>
            <button type="button" class="link" @click="toggleCity" v-else-if="cityLinks.length > maxCount && !showMore.city">See More</button>
        </div>
        <div class="seo-list" v-if="zipcodeLinks && zipcodeLinks.length">
            <div class="text-bold">{{molang('search.common.zipCodes')}}</div>
            <ul>
                <template v-for="(item, i) in zipcodeLinks" :key="i">
                    <li v-if="item.zipcodePath" v-show="showMore.zipcode || i < maxCount">
                        <a class="link" :href="glb.appUrl + item.zipcodePath" :title="molang(`search.common.seoLinksTitleTooltip${glb.rentLang}`, {displayName: item.zipcode, stateCode: item.state })" :count="$filters.formatFriendlyPrice(item.medianListPrice, '-')">
                            {{linkPrefix}} {{item.zipcode}}{{`, ${item.state}`}}
                        </a>
                    </li>
                </template>
            </ul>
            <a v-if="showSiteMapLinks && glb.geo.cityPath" :href="glb.appUrl + 'sitemap/' + glb.geo.cityPath" class="link">See More</a>
            <button type="button" class="link" @click="toggleZipcode" v-if="zipcodeLinks.length > maxCount && !showMore.zipcode">See More</button>
        </div>
        <div class="seo-list" v-if="neighborhoodLinks && neighborhoodLinks.length">
            <div class="text-bold">{{molang('search.common.neighborhoods')}}</div>
            <ul>
                <template v-for="(item, i) in neighborhoodLinks" :key="i">
                    <li v-if="item.neighborhoodPath && item.neighborhood" v-show="showMore.neighborhood || i < maxCount">
                        <a class="link" :href="glb.appUrl + item.neighborhoodPath" :title="molang(`search.common.seoLinksTitleTooltip${glb.rentLang}`, {displayName: item.neighborhood, stateCode: item.state })"  :count="$filters.formatFriendlyPrice(item.medianListPrice, '-')">
                            {{linkPrefix}} {{item.neighborhood}}
                        </a>
                    </li>
                </template>
            </ul>
            <a v-if="showSiteMapLinks && glb.geo.cityPath" :href="glb.appUrl + 'sitemap/' + glb.geo.cityPath" class="link">See More</a>
            <button type="button" class="link" @click="toggleNeighborhood" v-if="neighborhoodLinks.length > maxCount && !showMore.neighborhood">See More</button>
        </div>
        <div class="seo-list" v-if="countyLinks && countyLinks.length">
            <div class="text-bold" v-text="molang('search.common.counties')"></div>
            <ul>
                <template v-for="(item, i) in countyLinks" :key="i">
                    <li v-if="item.countyPath" v-show="showMore.county || i < maxCount">
                        <a class="link" :href="glb.appUrl + item.countyPath" :title="molang(`search.common.seoLinksTitleTooltip${glb.rentLang}`, {displayName: item.county, stateCode: item.state })" :count="$filters.formatFriendlyPrice(item.medianListPrice, '-')">
                            {{linkPrefix}} {{item.county}}
                        </a>
                    </li>
                </template>
            </ul>
            <a v-if="showSiteMapLinks" :href="glb.appUrl + 'sitemap/' + countyLinks[0].stateCode + '/county/'" class="link">See More</a>
            <button type="button" class="link" @click="toggleCounty" v-if="countyLinks.length > maxCount && !showMore.county">See More</button>
        </div>
    </div>
</template>

<script src="./mvt-seolink.js"></script>

<style lang="scss">
@use './mvt-seolink.scss' as *;
</style>
